import request from "@/api";

export function listGoods(data) {
    return request({
        url: '/api/goods/getGoodsList',
        method: 'get',
        params: data
    })
}

export function getGoodsInfo(data) {
    return request({
        url: '/api/goods/getGoodsInfo',
        method: 'get',
        params: data
    })
}

export function saveGoods(data) {
    return request({
        url: '/api/goods/saveGoods',
        method: 'post',
        data: data
    })
}

export function deleteGoods(data) {
    return request({
        url: '/api/goods/deleteGoods',
        method: 'post',
        data: data
    })
}

export function deleteBatchGoods(data) {
    return request({
        url: '/api/goods/deleteBatchGoods',
        method: 'post',
        data: data
    })
}


export function exportGoods(data) {
    return request({
        url: '/api/goods/export',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}